﻿window.messageresolver = function () {
    var instance = {
        Popupmessage: function (object) {

            var message = object.message;

            Toast.add({
                body: message,
                color: '#28a745',
                autohide: true,
                delay: 5000
            });
        },

        Сontrollermessage: function (object) {

            var sender = object.sender;
            var form = object.form;
            var message = object.message
            var messageaction = object.messageaction;

            sender.setAttribute('data-e', messageaction);
            sender.setAttribute('data-p-message', message);
            return ajaxUtils.formSubmit(sender, form)

        }
    }
    return instance;
}();